"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const LockOutlined_1 = __importDefault(require("@mui/icons-material/LockOutlined"));
const Language_1 = __importDefault(require("@mui/icons-material/Language"));
const NotificationsNone_1 = __importDefault(require("@mui/icons-material/NotificationsNone"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../../common/services/apiService"));
const pushService_1 = __importDefault(require("../../../../common/services/pushService"));
const globalVariables_1 = require("../../../../common/globalVariables");
const SettingsPageContainer = styled_components_1.default.div `
  max-width: ${props => props.maxWidth}px;
  margin: 0 auto;
  height: calc(100svh - 60px);
  display: flex;
  flex-direction: column;
  padding: 16px;

  .notification-section {
    display: flex;
    justify-content: space-between;

    .notificaiton-icon-text {
      display: flex;
    }
  }

  .learn-more-btn {
    color: ${props => props.theme.palette.mainAppColor.main};
    font-weight: bold;
    cursor: pointer;
  }

  .notification-info {
    margin: 16px 0;
  }

  .notification-info-link {
    cursor: pointer;
    color: ${props => props.theme.palette.mainAppColor.main};
    text-decoration: underline !important;
    font-weight: bold;
  }

  .MuiSwitch-switchBase.Mui-checked {
    color: ${props => props.theme.palette.mainAppColor.main};
  }

  .Mui-checked + .MuiSwitch-track {
    background-color: ${props => props.theme.palette.mainAppColor.light};
  }
`;
const SettingsAccountDetails = styled_components_1.default.div `
  text-align: center;

  @media screen and (max-width: 640px) {
    padding: 16px;
  }

  @media screen and (min-width: 641px) and (max-width: 1024px) {
    padding: 25px;
  }

  @media screen and (min-width: 1024px) {
    padding: 25px 10px 20px;
  }

  p {
    color: rgba(0, 0, 0, 0.6);
    margin: 0;
    letter-spacing: 0.25px;
  }

  .user-details {
    font-weight: 700;
    margin-bottom: 5px;
    letter-spacing: 0.5px;
  }
`;
const SettingsWrapper = styled_components_1.default.div `
  width: 100%;
  background: #fff;
  flex-grow: 1;

  .expanded .language-title span {
    font-size: 20px;
  }

  .logout-button,
  .login-button {
    margin-top: 25px;

    @media screen and (min-width: 1024px) {
      margin-top: 60px;
    }
  }
`;
const BtnWrapper = styled_components_1.default.div `
  button {
    margin: 0px auto 16px;
    display: block;
  }
`;
const LogoutBtnWrapper = styled_components_1.default.div `
  padding: 12px;
  position: sticky;
  bottom: 0;

  button {
    margin: 0 auto;
    display: block;
  }
`;
const listItemStyle = {
    div: {
        padding: '12px',
        cursor: 'pointer',
    },
    icon: {
        marginRight: '15px',
    },
    languageRow: {
        justifyContent: 'space-between',
    },
    languageAbbreviation: {
        flex: 'initial',
        textTransform: 'capitalize',
        color: '#000',
        opacity: '.6',
        fontSize: '14px',
    },
    changeHotelIcon: {
        color: '#ff0000',
    },
    dataProtectionBlock: {
        marginTop: '60px',
    },
    conventionsIcon: {
        height: '24px',
        width: '24px',
    },
};
const SettingsPage = (props) => {
    const { venue, appData, pushNotificationsEnabled,
    // userData,
    // currentLocale,
    // updateStore,
     } = props;
    const [isLoggedIn, setIsLoggedIn] = (0, react_1.useState)(props.userData.loginProviders.length > 0 && props.userData.loginProviders[0].loggedIn);
    const { firstName, lastName } = props.userData.account;
    const showPrivacyStatement = () => {
        window.open(venue.privacyStatementUrl, '_blank');
    };
    const logout = () => {
        apiService_1.default.logOut(props.userData.token, props.userData.loginProviders[0].slug).then(userData => {
            props.history.push({
                pathname: `${props.baseUrl}`,
            });
            props.updateStore('userData', userData);
            setIsLoggedIn(false);
        });
    };
    const login = () => {
        props.history.push({
            pathname: `${props.baseUrl}/profile`,
        });
    };
    const showLanguage = () => {
        props.history.push({
            pathname: `${props.match.url}/language`,
            search: props.location.search,
        });
    };
    const handleNotificationChange = evt => {
        if ('Notification' in window && Notification.permission === 'denied') {
            return;
        }
        if (evt.target.checked) {
            const setToggleTo = value => {
                props.updateStore('pushNotificationsEnabled', value);
            };
            pushService_1.default.requestNotificationPermission(appData.vapidPublicKey, props.userData.token, props.currentLocale, setToggleTo);
        }
        if (!evt.target.checked) {
            props.updateStore('pushNotificationsEnabled', false);
            pushService_1.default.disablePushService(props.userData.token, props.currentLocale);
        }
    };
    const notificationInfoContent = !pushNotificationsEnabled ? (react_1.default.createElement(material_1.Typography, { variant: "body1", className: "notification-info" },
        i18n_js_1.default.t('your_notifications_are_blocked'),
        react_1.default.createElement("a", { href: "https://help.hotel-mssngr.com/en/articles/8965701-how-to-activate-push-notifications", target: "_blank", rel: "noreferrer", className: "notification-info-link" }, i18n_js_1.default.t('learn_more_about_notifications_how_to_enable_notifications')))) : (react_1.default.createElement(material_1.Typography, { variant: "body1", className: "notification-info", onClick: () => {
            window.open('https://help.hotel-mssngr.com/en/articles/8965701-how-to-activate-push-notifications', '_blank');
        }, dangerouslySetInnerHTML: {
            __html: i18n_js_1.default.t('learn_more_about_notifications', {
                class: 'notification-info-link',
            }),
        } }));
    return (react_1.default.createElement(SettingsPageContainer, { maxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER },
        props.userData.loginProviders.length > 0 && !isLoggedIn && (react_1.default.createElement(BtnWrapper, null,
            react_1.default.createElement(material_1.Button, { onClick: login, variant: "contained", size: "large", fullWidth: true }, i18n_js_1.default.t('login')))),
        isLoggedIn && (react_1.default.createElement(SettingsAccountDetails, null,
            react_1.default.createElement(material_1.Typography, { className: "user-details", variant: "h6" },
                ' ',
                firstName,
                " ",
                lastName,
                ' '),
            react_1.default.createElement(material_1.Typography, { variant: "body2" },
                " ",
                `${i18n_js_1.default.t('account_logged_on')} ${venue.title}`,
                " "))),
        react_1.default.createElement(SettingsWrapper, null,
            react_1.default.createElement(material_1.List, null,
                react_1.default.createElement(material_1.ListItem, { onClick: showLanguage, style: listItemStyle.div },
                    react_1.default.createElement(Language_1.default, { style: listItemStyle.icon }),
                    react_1.default.createElement(material_1.Typography, { variant: "body1" },
                        " ",
                        i18n_js_1.default.t('languages_label'),
                        " ")),
                react_1.default.createElement(material_1.Divider, null),
                window.usercentrics ? (react_1.default.createElement(material_1.ListItem, { onClick: () => {
                        window.usercentrics.showSettings();
                    }, style: listItemStyle.div },
                    react_1.default.createElement(LockOutlined_1.default, { style: listItemStyle.icon }),
                    react_1.default.createElement(material_1.Typography, { variant: "body1" },
                        " ",
                        i18n_js_1.default.t('change_privacy_settings_button'),
                        " "))) : (react_1.default.createElement(material_1.ListItem, { onClick: showPrivacyStatement, style: listItemStyle.div },
                    react_1.default.createElement(LockOutlined_1.default, { style: listItemStyle.icon }),
                    react_1.default.createElement(material_1.Typography, { variant: "body1" },
                        " ",
                        i18n_js_1.default.t('privacy_statement'),
                        " "))),
                react_1.default.createElement(material_1.Divider, null),
                'Notification' in window && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(material_1.ListItem, { onClick: () => { }, style: listItemStyle.div, className: "notification-section" },
                        react_1.default.createElement("div", { className: "notificaiton-icon-text" },
                            react_1.default.createElement(NotificationsNone_1.default, { style: listItemStyle.icon }),
                            react_1.default.createElement(material_1.Typography, { variant: "body1" },
                                " ",
                                i18n_js_1.default.t('notifications_header'),
                                " ")),
                        react_1.default.createElement(Switch_1.default, { className: "notification-toggle", checked: pushNotificationsEnabled, onChange: handleNotificationChange, color: "primary", inputProps: { 'aria-label': 'controlled' }, disabled: 'Notification' in window && Notification.permission === 'denied' })),
                    react_1.default.createElement(material_1.Divider, null),
                    notificationInfoContent)))),
        isLoggedIn && (react_1.default.createElement(LogoutBtnWrapper, null,
            react_1.default.createElement(material_1.Button, { fullWidth: true, onClick: logout, variant: "outlined", size: "large", color: "destroy" }, i18n_js_1.default.t('logout'))))));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    userData: store.getValue('userData'),
    navigations: store.getValue('navigations'),
    venue: store.getValue('venue'),
    currentLocale: store.getValue('currentLocale'),
    enabledLocales: store.getValue('enabledLocales'),
    appData: store.getValue('appData'),
    pushNotificationsEnabled: store.getValue('pushNotificationsEnabled'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(SettingsPage));
